(function () {
  function init(section) {
    if (section.dataset.msPdpInit === 'true') return;
    section.dataset.msPdpInit = 'true';

    var jsonEl = section.querySelector('[data-product-json]');
    var productData = { variants: [] };
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent) || { variants: [] }; } catch (err) { productData = { variants: [] }; }
    }

    var form = section.querySelector('[data-product-form]');
    var variantInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var priceKg = section.querySelector('[data-price-kg]');
    var priceKgMin = section.querySelector('[data-price-kg-min]');
    var priceKgMax = section.querySelector('[data-price-kg-max]');
    var pesoKg = parseFloat(section.getAttribute('data-peso-kg') || '0');
    var pesoKgMax = parseFloat(section.getAttribute('data-peso-kg-max') || '0');
    var unitDivisor = parseFloat(section.getAttribute('data-unit-divisor') || '0');
    var klarnaAmount = section.querySelector('[data-klarna-amount]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var optionGroups = section.querySelectorAll('[data-option-group]');
    var radios = section.querySelectorAll('[data-variant-option]');
    var stickyBar = section.querySelector('[data-sticky-bar]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyLabel = section.querySelector('[data-sticky-label]');
    var gar = section.querySelector('[data-gar]');
    var errorBox = section.querySelector('[data-add-error]');

    var labels = {
      add: section.dataset.labelAdd || '',
      adding: section.dataset.labelAdding || '',
      added: section.dataset.labelAdded || '',
      soldout: section.dataset.labelSoldout || ''
    };

    var moneyFormatter = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100) + ' €';
    }

    function getCurrentVariant() {
      if (!variantInput) return null;
      var id = parseInt(variantInput.value, 10);
      for (var i = 0; i < productData.variants.length; i++) {
        if (productData.variants[i].id === id) return productData.variants[i];
      }
      return null;
    }

    function renderLabel(node, attr, variant) {
      if (!node || !variant) return;
      node.textContent = '';
      var span = document.createElement('span');
      span.setAttribute(attr, '');
      span.textContent = formatMoney(variant.price);
      node.appendChild(document.createTextNode(labels.add + ' · '));
      node.appendChild(span);
    }

    function setButtons(variant) {
      if (!variant) return;
      if (variant.available) {
        if (addBtn) addBtn.disabled = false;
        renderLabel(addLabel, 'data-add-price', variant);
        if (stickyAdd) stickyAdd.disabled = false;
        renderLabel(stickyLabel, 'data-sticky-price', variant);
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = labels.soldout;
        if (stickyAdd) stickyAdd.disabled = true;
        if (stickyLabel) stickyLabel.textContent = labels.soldout;
      }
    }

    function setShipping(variant) {
      if (!gar || !variant) return;
      var limit = parseInt(gar.getAttribute('data-gratis-cents') || '0', 10);
      var free = gar.querySelector('[data-gar-envio-gratis]');
      var paid = gar.querySelector('[data-gar-envio-pago]');
      if (!free || !paid) return;
      var isFree = variant.price >= limit;
      free.hidden = !isFree;
      paid.hidden = isFree;
    }

    var gal = section.querySelector('[data-gal]');
    var track = gal ? gal.querySelector('[data-gal-track]') : null;
    var slides = gal ? gal.querySelectorAll('[data-gal-slide]') : [];
    var thumbs = gal ? gal.querySelectorAll('[data-gal-thumb]') : [];
    var thumbsList = gal ? gal.querySelector('[data-gal-thumbs]') : null;
    var galCurrent = gal ? gal.querySelector('[data-gal-current]') : null;
    var galPrev = gal ? gal.querySelector('[data-gal-prev]') : null;
    var galNext = gal ? gal.querySelector('[data-gal-next]') : null;
    var active = gal ? parseInt(gal.getAttribute('data-gal-start') || '0', 10) : 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markActive(index) {
      active = index;
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
      if (galCurrent) galCurrent.textContent = String(index + 1);
      if (galPrev) galPrev.disabled = index <= 0;
      if (galNext) galNext.disabled = index >= slides.length - 1;
      var thumb = thumbs[index];
      if (thumb && thumbsList) {
        var item = thumb.parentElement;
        if (thumbsList.scrollWidth > thumbsList.clientWidth) {
          var left = item.offsetLeft - (thumbsList.clientWidth - item.offsetWidth) / 2;
          thumbsList.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
        } else if (thumbsList.scrollHeight > thumbsList.clientHeight) {
          var top = item.offsetTop - (thumbsList.clientHeight - item.offsetHeight) / 2;
          thumbsList.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }

    function goTo(index, instant) {
      if (!track || !slides.length) return;
      var target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[target].offsetLeft - track.offsetLeft, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      markActive(target);
    }

    if (track && slides.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          index = Math.max(0, Math.min(slides.length - 1, index));
          if (index !== active) markActive(index);
        });
      }, { passive: true });

      for (var t = 0; t < thumbs.length; t++) {
        (function (thumb) {
          thumb.addEventListener('click', function () {
            goTo(parseInt(thumb.getAttribute('data-index') || '0', 10));
          });
        })(thumbs[t]);
      }

      if (galPrev) galPrev.addEventListener('click', function () { goTo(active - 1); });
      if (galNext) galNext.addEventListener('click', function () { goTo(active + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });

      if (active > 0) goTo(active, true); else markActive(0);
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
      }
    }

    var lb = section.querySelector('[data-lb]');
    if (lb && slides.length) {
      var lbImg = lb.querySelector('[data-lb-img]');
      var lbView = lb.querySelector('[data-lb-view]');
      var lbCurrent = lb.querySelector('[data-lb-current]');
      var lbTotal = lb.querySelector('[data-lb-total]');
      var lbPrev = lb.querySelector('[data-lb-prev]');
      var lbNext = lb.querySelector('[data-lb-next]');
      var lbClose = lb.querySelector('[data-lb-close]');
      var lbIndex = 0;
      var lbTrigger = null;
      var zooms = gal.querySelectorAll('[data-gal-zoom]');

      if (lbTotal) lbTotal.textContent = String(zooms.length);
      if (zooms.length < 2) {
        if (lbPrev) lbPrev.hidden = true;
        if (lbNext) lbNext.hidden = true;
      }

      function lbShow(index) {
        lbIndex = (index + zooms.length) % zooms.length;
        var source = zooms[lbIndex];
        var thumbImg = source.querySelector('img');
        lb.classList.remove('is-zoomed');
        lbView.scrollTop = 0;
        lbView.scrollLeft = 0;
        if (thumbImg) {
          lbImg.alt = thumbImg.alt || '';
          lbImg.width = thumbImg.getAttribute('width') || 1200;
          lbImg.height = thumbImg.getAttribute('height') || 1200;
          lbImg.src = thumbImg.currentSrc || thumbImg.src;
        }
        var full = source.getAttribute('data-full');
        if (full) {
          var loader = new Image();
          var expected = lbIndex;
          loader.onload = function () { if (expected === lbIndex) lbImg.src = full; };
          loader.src = full;
        }
        if (lbCurrent) lbCurrent.textContent = String(lbIndex + 1);
      }

      function lbOpen(index, trigger) {
        lbTrigger = trigger || null;
        lb.hidden = false;
        document.documentElement.classList.add('ms-lb-open');
        lbShow(index);
        if (lbClose) lbClose.focus();
      }

      function lbShut() {
        lb.hidden = true;
        lb.classList.remove('is-zoomed');
        document.documentElement.classList.remove('ms-lb-open');
        goTo(lbIndex, true);
        var back = zooms[lbIndex] || lbTrigger;
        if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
      }

      for (var z = 0; z < zooms.length; z++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            lbOpen(parseInt(btn.getAttribute('data-index') || '0', 10), btn);
          });
        })(zooms[z]);
      }

      if (lbClose) lbClose.addEventListener('click', lbShut);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });

      lbView.addEventListener('click', function (e) {
        if (e.target === lbView) { lbShut(); return; }
        var rect = lbImg.getBoundingClientRect();
        var rx = rect.width ? (e.clientX - rect.left) / rect.width : 0.5;
        var ry = rect.height ? (e.clientY - rect.top) / rect.height : 0.5;
        var zoomed = lb.classList.toggle('is-zoomed');
        if (zoomed) {
          window.requestAnimationFrame(function () {
            lbView.scrollLeft = rx * lbView.scrollWidth - lbView.clientWidth / 2;
            lbView.scrollTop = ry * lbView.scrollHeight - lbView.clientHeight / 2;
          });
        }
      });

      var touchX = null;
      var touchY = null;
      lbView.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || lb.classList.contains('is-zoomed')) { touchX = null; return; }
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }, { passive: true });
      lbView.addEventListener('touchend', function (e) {
        if (touchX === null || zooms.length < 2) return;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) lbShow(lbIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') { lbShut(); return; }
        if (e.key === 'ArrowRight') { lbShow(lbIndex + 1); return; }
        if (e.key === 'ArrowLeft') { lbShow(lbIndex - 1); return; }
        if (e.key === 'Tab') {
          var focusables = lb.querySelectorAll('button:not([hidden])');
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    function setRow(key, value) {
      var node = section.querySelector('[data-cesta-value="' + key + '"]');
      if (!node) return;
      var row = node.closest('[data-cesta-row]');
      var text = value === null || value === undefined ? '' : String(value);
      node.textContent = text;
      if (row) row.hidden = text.trim() === '';
    }

    function syncRows(variant) {
      if (!variant || !section.hasAttribute('data-ms-cesta')) return;
      var nota = section.querySelector('[data-cesta-nota]');
      if (nota) { nota.textContent = variant.nota || ''; nota.hidden = !variant.nota; }
      setRow('alimentacion', variant.alimentacion);
      setRow('peso', variant.peso);
      setRow('curacion', variant.curacion ? variant.curacion + ' meses' : '');
      setRow('precinto', variant.precinto);
      setRow('do', variant.do);
      setRow('raciones', variant.raciones);
      var list = section.querySelector('[data-cesta-pieza]');
      if (list) list.hidden = !list.querySelector('[data-cesta-row]:not([hidden])');
    }

    function applyVariant(matched) {
      if (!matched || !variantInput) return;
      variantInput.value = matched.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(matched.price);
      if (priceKg && unitDivisor > 0) priceKg.textContent = formatMoney(Math.round(matched.price / unitDivisor));
      if (priceKgMin && pesoKgMax > 0) priceKgMin.textContent = formatMoney(Math.round(matched.price / pesoKgMax));
      if (priceKgMax && pesoKg > 0) priceKgMax.textContent = formatMoney(Math.round(matched.price / pesoKg));
      if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(matched.price / 3));
      if (priceCompare) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          priceCompare.textContent = formatMoney(matched.compare_at_price);
          priceCompare.removeAttribute('hidden');
        } else {
          priceCompare.setAttribute('hidden', '');
          priceCompare.textContent = '';
        }
      }
      setButtons(matched);
      setShipping(matched);
      syncRows(matched);
      goToMedia(matched.media_id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());
    }

    for (var r = 0; r < radios.length; r++) {
      radios[r].addEventListener('change', function () {
        var selected = [];
        for (var g = 0; g < optionGroups.length; g++) {
          var checked = optionGroups[g].querySelector('input:checked');
          if (checked) selected.push(checked.value);
        }
        var matched = null;
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          if (v.options.length !== selected.length) continue;
          var same = true;
          for (var o = 0; o < v.options.length; o++) {
            if (v.options[o] !== selected[o]) { same = false; break; }
          }
          if (same) { matched = v; break; }
        }
        applyVariant(matched);
      });
    }

    syncRows(getCurrentVariant());

    var gift = section.querySelector('[data-cesta-gift]');
    var giftCount = section.querySelector('[data-cesta-gift-count]');
    if (gift && giftCount) {
      gift.addEventListener('input', function () { giftCount.textContent = gift.value.length; });
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    }

    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        if (addBtn.disabled) { e.preventDefault(); return; }
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart) return;
        e.preventDefault();
        showError('');

        var formData = new FormData(form);
        if (typeof cart.getSectionsToRender === 'function') {
          var ids = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          formData.append('sections', ids);
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }

        addBtn.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        if (addLabel) addLabel.textContent = labels.adding;
        if (stickyLabel) stickyLabel.textContent = labels.adding;

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        }).then(function (result) {
          if (!result.ok) throw new Error((result.data && (result.data.description || result.data.message)) || '');
          if (addLabel) addLabel.textContent = labels.added;
          if (stickyLabel) stickyLabel.textContent = labels.added;
          if (typeof cart.renderContents === 'function') {
            cart.renderContents(result.data);
          } else {
            cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open(addBtn);
          }
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: result.data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(function () { setButtons(getCurrentVariant()); }, 1500);
        }).catch(function (err) {
          showError(err && err.message ? err.message : 'No se ha podido añadir. Probad de nuevo o escribidme por WhatsApp.');
          setButtons(getCurrentVariant());
        });
      });
    }

    if (stickyBar && stickyAdd && addBtn) {
      var actionsEl = section.querySelector('.ms-product__actions');
      var setSticky = function (visible) {
        stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
        if (visible) stickyBar.removeAttribute('inert'); else stickyBar.setAttribute('inert', '');
        document.documentElement.classList.toggle('ms-sticky-on', visible);
      };
      setSticky(false);
      if (actionsEl) {
        var stickyTick = false;
        var checkSticky = function () {
          stickyTick = false;
          var rect = actionsEl.getBoundingClientRect();
          var next = rect.bottom < 0 || rect.top > (window.innerHeight || document.documentElement.clientHeight);
          if (String(next) !== stickyBar.getAttribute('data-visible')) setSticky(next);
        };
        window.addEventListener('scroll', function () {
          if (stickyTick) return;
          stickyTick = true;
          window.requestAnimationFrame(checkSticky);
        }, { passive: true });
        checkSticky();
      }
      stickyAdd.addEventListener('click', function () {
        if (addBtn.disabled || !form) return;
        var below = actionsEl && actionsEl.getBoundingClientRect().top > (window.innerHeight || document.documentElement.clientHeight);
        var needsChoice = radios.length > 1 || !!section.querySelector('[data-cesta-gift]');
        if (below && needsChoice) {
          form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) {
      var accordions = section.querySelectorAll('.ms-product__accordion');
      for (var a = 0; a < accordions.length; a++) accordions[a].open = true;
    }

    var fadeEls = section.querySelectorAll('[data-fade]');
    if (fadeEls.length && 'IntersectionObserver' in window) {
      var fadeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });
      fadeEls.forEach(function (el) { fadeObs.observe(el); });
    } else {
      fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  function boot() {
    var sections = document.querySelectorAll('.ms-product');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
